import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { getCatalogues, cataloguesQueryKeys } from '@api/catalogues';
import { ApiError } from '@api/client';
import type { CataloguesListParams } from '@api/catalogues';

const ALL_CATALOGUES_PARAMS: CataloguesListParams = {
  perPage: 500,
  sortBy: 'year',
  sortDirection: 'desc',
};

export function useCatalogues() {
  return useQuery({
    queryKey: cataloguesQueryKeys.list(ALL_CATALOGUES_PARAMS),
    queryFn: () => getCatalogues(ALL_CATALOGUES_PARAMS),
    staleTime: 5 * 60_000,
    placeholderData: keepPreviousData,
    select: (data) => data.catalogues,
    retry: (failureCount, error) => {
      if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
        return false;
      }
      return failureCount < 3;
    },
  });
}
